<p>Appointment carousel works!</p>